module.exports = __webpack_public_path__ + "img/fail.1f66690d.png";